/* global gsap*/
/* global Swiper */
(function (window, $) {
  'use strict';
  // Set Namespace
  var APP = window.APP = window.APP || {};

  $(function () {
    // ページ内リンク
    function smoothScroll(target) {
      var $target = $(target);
      var headerHeight = $('.l-header').outerHeight();
      $('html, body').stop().scrollTop(0);
      if ($target.length) {
        $('html, body').stop().animate({
          'scrollTop': $target.offset().top - headerHeight
        }, 500, 'swing');
      }
    }
    // ページ読み込み時の処理
    if (window.location.hash) {
      smoothScroll(window.location.hash);
    }
    // ページ内リンククリック時の処理
    $('a[href^="#"]').on('click', function () {
      if (!$(this).hasClass('no-scroll')) {
        smoothScroll(this.hash);
        return false;
      }
    });

    // スクロールでヘッダーに背景色を付与
    $(window).on('scroll', function () {
      if (50 < $(this).scrollTop()) {
        $('.l-header').addClass('is-color');
        $('.js-header-logo a').addClass('is-color');
        $('.p-header-menu ul li a').addClass('is-color');
      } else {
        $('.l-header').removeClass('is-color');
        $('.js-header-logo a').removeClass('is-color');
        $('.p-header-menu ul li a').removeClass('is-color');
      }
    });

    // TOP以外（下層ページ）の場合、背景色を変える
    $(window).on('load', function () {
      if ($('.c-lower-header').length > 0) {
        $('.l-header').addClass('page-color');
        $('.js-header-logo a').addClass('page-color');
        $('.p-header-menu ul li a').addClass('page-color');
      }
    });

    $(function () {
      // 「数字で見る」のカウントアップ
      const countUpTargets = document.querySelectorAll('.js-countUp-target-about');
      countUpTargets.forEach(countUpTarget => {
        let elementNum = {
          count: parseFloat(countUpTarget.dataset.from),
        };
        const toValue = parseFloat(countUpTarget.dataset.to);
        const isYear = countUpTarget.classList.contains('is-year');
        const toValueIsFloat = toValue % 1 !== 0 || countUpTarget.dataset.to.includes('.');
        gsap.to(elementNum, {
          count: toValue,
          duration: 1,
          ease: 'none',
          onUpdate: () => {
            let formattedCount;
            if (toValueIsFloat) {
              const parts = elementNum.count.toFixed(1).split('.');
              formattedCount = `${parseInt(parts[0]).toLocaleString()}<span class="small">.${parts[1]}</span>`;
            } else {
              const countValue = Math.floor(elementNum.count);
              if (isYear && countValue.toString().length === 4) {
                formattedCount = countValue.toString();
              } else {
                formattedCount = countValue.toLocaleString();
              }
            }
            countUpTarget.innerHTML = formattedCount;
          },
          scrollTrigger: {
            trigger: countUpTarget,
            start: 'top bottom',
            toggleActions: 'play none none none',
          },
        });
      });
    });

    // フェードイン グラフ Y
    $(function () {
      var graphIn = $('.graph-in-y');
      $(window).scroll(function () {
        $(graphIn).each(function () {
          var offset = $(this).offset().top;
          var scroll = $(window).scrollTop();
          var windowHeight = $(window).height();
          if (scroll > offset - windowHeight - 100) {
            $(this).addClass('scroll-graph-y');
          }
        });
      });
    });

    // サイトアニメーション
    // スライドイン（下から上に）
    const animationUp = document.querySelectorAll('.animation-up');
    animationUp.forEach((content) => {
      gsap.fromTo(content, { autoAlpha: 0, y: 20 }, {
        delay: 0.2, duration: 0.5, autoAlpha: 1, y: 0, scrollTrigger: {
          trigger: content,
          // start: 'bottom bottom',
          start: '50px bottom',
          //markers: true,
        }
      });
    });

    // 左から表示
    const animationLeft = document.querySelectorAll('.animation-left');
    if (animationLeft.length > 0) {
      animationLeft.forEach((content) => {
        const delay = content.dataset.delay || 0.2;
        gsap.fromTo(content, { autoAlpha: 0, x: -30 }, { // eslint-disable-line
          delay: delay,
          duration: 0.3,
          autoAlpha: 1,
          x: 0,
          scrollTrigger: {
            trigger: content,
            start: '30px bottom',
          }
        });
      });
    }

    // 右から表示
    const animationRight = document.querySelectorAll('.animation-right');
    if (animationRight.length > 0) {
      animationRight.forEach((content) => {
        const delay = content.dataset.delay || 0.2; // `data-delay`属性がない場合はデフォルト0.2
        gsap.fromTo(content, { autoAlpha: 0, x: 30 }, { // eslint-disable-line
          delay: delay,
          duration: 0.3,
          autoAlpha: 1,
          x: 0,
          scrollTrigger: {
            trigger: content,
            start: '30px bottom',
          }
        });
      });
    }
  });

  //header・drawerメニュー
  // メインのボタンにクリックイベントを追加する
  document.getElementById('js-toggle-btn').addEventListener('click', function (event) {
    event.stopPropagation(); // メインボタンのクリックが親要素に伝搬しないようにする
    togglePanel();
  });

  // ドキュメント全体にクリックイベントを追加して、メニューを閉じる
  document.addEventListener('click', function (event) {
    var target = event.target;
    var isHeaderNav = target.closest('.p-header-nav');
    var isDrawerNav = target.closest('.p-drawer-nav');
    var isToggleBtn = target.closest('#js-toggle-btn');
    if (!isHeaderNav && !isDrawerNav && !isToggleBtn) {
      closePanel();
    }
  });

  // パネルを開く・閉じる関数を定義する
  function togglePanel() {
    // var toggleBtn = document.getElementById('js-toggle-btn');
    // var toggleBar = document.getElementById('js-toggle-bar');
    var headerNav = document.getElementById('js-header-nav');
    //var drawerNav = document.getElementById('js-drawer-nav');

    if (document.body.classList.contains('is-menu-open')) {
      headerNav.style.opacity = '0';
      headerNav.style.visibility = 'hidden';
      headerNav.style.transform = 'translateY(100px)';
      document.body.classList.remove('is-menu-open');
      // toggleBtn.classList.remove('is-active');
      // toggleBar.classList.remove('is-active');
    } else {
      headerNav.style.opacity = '1';
      headerNav.style.visibility = 'visible';
      headerNav.style.transform = 'translateY(0)';
      document.body.classList.add('is-menu-open');
      // toggleBtn.classList.add('is-active');
      // toggleBar.classList.add('is-active');
    }
  }

  // パネルを閉じる関数を定義する
  function closePanel() {
    // var toggleBar = document.getElementById('js-toggle-bar');
    var headerNav = document.getElementById('js-header-nav');

    if (document.body.classList.contains('is-menu-open')) {
      headerNav.style.opacity = '0';
      headerNav.style.visibility = 'hidden';
      headerNav.style.transform = 'translateY(100px)';
      document.body.classList.remove('is-menu-open');
    }
  }

  // ヘッダー内のリンクにクリックイベントを追加する
  document.querySelectorAll('.p-header-nav a').forEach(link => {
    link.addEventListener('click', closePanel);
  });

  $(function () {
    // TOP 私たちのメッセージ パララックス効果
    document.addEventListener('scroll', () => {
      const section = document.querySelector('.p-home-ourmessage');
      const sectionTop = section.getBoundingClientRect().top;
      const sectionHeight = section.getBoundingClientRect().height;

      const largeElements = document.querySelectorAll('.bg.large');
      const smallElements = document.querySelectorAll('.bg.small');

      if (sectionTop < window.innerHeight && sectionTop + sectionHeight > 0) {
        // スクロール範囲内のみ視差効果を発動
        const scrollY = window.scrollY - section.offsetTop;

        largeElements.forEach(el => {
          const speed = 0.1;
          el.style.transform = `translateY(${scrollY * speed}px)`;
        });

        smallElements.forEach(el => {
          const speed = -0.05;
          el.style.transform = `translateY(${scrollY * speed}px)`;
        });
      }
    });
  });

  document.addEventListener('DOMContentLoaded', () => {
    function topSwiper() {
      // TOP kvスライダー
      const topSwiper = new Swiper('.js-kv-slider', {
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        direction: 'vertical',
        loopAdditionalSlides: 1,
        speed: 2000,
        loop: true,
        slidesPerView: 1,
        autoplay: {
          delay: 7000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
          reverseDirection: false,
          waitForTransition: false,
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        },
        followFinger: false,
      });
    }

    function interviewSwiper() {
      // 先輩インタビュースライダー
      const interviewSwiper = new Swiper('.js-interview-slider', {
        centeredSlides: true,
        loop: true,
        speed: 500,
        watchSlidesProgress: true,
        grabCursor: true,
        loopAdditionalSlides: 1,
        resizeObserver: true,
        observer: true,
        observeParents: true,
        breakpoints: {
          300: {
            slidesPerView: 1.8,
            spaceBetween: 48,
          },
          500: {
            slidesPerView: 2.5,
            spaceBetween: 64,
          },
          600: {
            slidesPerView: 3.5,
            spaceBetween: 64,
          },
          768: {
            slidesPerView: 2.5,
            spaceBetween: 64,
          },
          1240: {
            slidesPerView: 3.5,
            spaceBetween: 64,
          }
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      });

      // 先輩インタビューを見るボタンクリックでスライドに移動
      const links = document.querySelectorAll('.c-works-interview-btn');
      links.forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          const slideIndex = parseInt(link.getAttribute('data-slide'), 10);
          interviewSwiper.slideTo(slideIndex);
        });
      });
    }

    setTimeout(() => {
      topSwiper();
      interviewSwiper();
    }, 100);

    window.addEventListener('resize', () => {
      setTimeout(() => {
        interviewSwiper.update();
      }, 100);
    });
  });

  /* eslint-disable consistent-this */
  $(function () {
    // トップページのカウントアップ
    initiateCountUp($('.js-top-number-contents.is-show'));

    $('.js-top-number-tab').on('click', function () {
      var $this = $(this);
      var $ancestorEle = $this.closest('.tab-contents-wrap');

      $ancestorEle.find('.js-top-number-tab.is-active').removeClass('is-active')
        .find('.tab-btn').removeClass('is-active');
      $this.addClass('is-active').find('.tab-btn').addClass('is-active');

      var $panels = $ancestorEle.find('.js-top-number-contents');
      $ancestorEle.find('.is-show').removeClass('is-show');
      var index = $this.index();
      $panels.eq(index).addClass('is-show');

      initiateCountUp($panels.eq(index));
    });
  });
  function initiateCountUp($panel) {
    const countUpTargets = $panel.find('.js-countUp-target');

    countUpTargets.each(function () {
      const countUpTarget = this;
      let elementNum = {
        count: parseFloat(countUpTarget.dataset.from),
      };
      const toValue = parseFloat(countUpTarget.dataset.to);
      const hasSmall = countUpTarget.querySelector('.small') !== null;

      gsap.to(elementNum, {
        count: toValue,
        duration: 1,
        ease: 'none',
        onUpdate: () => {
          let formattedCount;
          if (hasSmall) {
            // 小数点あり（小数1桁を表示）
            const parts = elementNum.count.toFixed(1).split('.');
            formattedCount = `${parts[0]}.<span class="small">${parts[1]}</span>`;
          } else {
            // 整数のみ
            formattedCount = Math.round(elementNum.count);
          }
          countUpTarget.innerHTML = formattedCount;
        },
        scrollTrigger: {
          trigger: countUpTarget,
          start: 'top bottom',
          toggleActions: 'play none none none',
        },
      });
    });
  }

  // SP表示で表がスクロールできるヒントを表示
  new ScrollHint('.js-scrollable', { // eslint-disable-line
    suggestiveShadow: true,
    i18n: {
      scrollable: 'スクロールできます'
    }
  });

  $(function () {
    // テキストの上にマーカーを引く
    window.addEventListener('scroll', function () {
      const height = window.innerHeight;
      const scroll = this.pageYOffset;
      const marker = document.querySelectorAll('.c-marker');
      const value = scroll - height + 100;

      marker.forEach(function (element) {
        if (scroll > element.getBoundingClientRect().top + value) {
          element.classList.add('on');
        }
      });
    });
  });

  // インタビュー動画の再生ボタンをカスタム
  $(function () {
    $('.p-page-interview-play').on('click', function () {
      const $video = $('.p-page-interview-video').get(0);

      if ($(this).hasClass('is-active')) {
        $video.pause();
      } else {
        $video.play();
      }
    });

    $('.p-page-interview-video').on('playing', function () {
      $('.p-page-interview-play').addClass('is-active');
      $('.p-page-interview-mov').addClass('is-active');
    });

    $('.p-page-interview-video').on('pause', function () {
      $('.p-page-interview-play').removeClass('is-active');
      $('.p-page-interview-mov').removeClass('is-active');
    });

    $('.p-page-interview-video').on('ended', function () {
      $('.p-page-interview-play').removeClass('is-active');
      $('.p-page-interview-mov').removeClass('is-active');
    });
  });

  $(function () {
    var $btn = $('.c-fixed-btn');
    var $footer = $('#footer');

    if ($btn.length === 0 || $footer.length === 0) {
      return;
    }

    var triggerHeight = $(window).height(); // ファーストビューの高さ

    function onScroll() {
      var scrollTop = $(window).scrollTop();
      var viewportBottom = scrollTop + $(window).height();
      var footerTop = $footer.offset().top;

      // 条件1: ファーストビューを超えている
      var passedFirstView = scrollTop > triggerHeight;
      // 条件2: footerに差し掛かっていない
      var notAtFooter = viewportBottom < footerTop;

      if (passedFirstView && notAtFooter) {
        $btn.addClass('visible'); // 表示
      } else {
        $btn.removeClass('visible'); // 非表示
      }
    }

    // 初期チェック
    onScroll();

    // スクロール＆リサイズ時に判定
    $(window).on('scroll resize', function () {
      triggerHeight = $(window).height(); // リサイズ時に更新
      onScroll();
    });
  });


})(window, jQuery);

